<template>
  <div>
    <div class="vx-row" v-if="contracts">
      <div class="vx-col lg:w-1/4 w-full m-base">
        <vx-card :title="`Huidig contract (${contract.contract_name})`">
          <contract-info :contract="contract"></contract-info>
        </vx-card>
      </div>
      <div class="vx-col  lg:w-1/2 w-full m-base">
        <vx-card
          title="Verhuizing doorgeven"
          :no-shadow="!contract.active"
          :card-background="!contract.active ? '#eeeeee' : ''"
          :content-color="!contract.active ? '#9e9e9e' : ''"
        >
          <vs-alert color="warning" active="true">
            Mocht je verhuizing eerder dan 7 dagen plaatsvinden of al
            plaatsgevonden hebben, mail dan naar
            <a href="mailto:service@naked-energy.nl">service@naked-energy.nl</a>
            zodat we dit zo snel mogelijk kunnen afhandelen.
          </vs-alert>
          <form-wizard
            color="rgba(var(--vs-primary), 1)"
            errorColor="rgba(var(--vs-danger), 1)"
            :title="null"
            :subtitle="null"
            finishButtonText="Versturen"
            nextButtonText="Volgende"
            backButtonText="Terug"
            v-if="!finished"
            @on-complete="onComplete"
          >
            <tab-content
              title="Nieuw adres"
              class="mb-5"
              icon="feather icon-home"
              :before-change="validateStep1"
            >
              <validation-observer ref="observerStep1">
                <div class="vx-row">
                  <div class="vx-col lg:w-1/2 w-full">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="vx-row mb-2">
                          <div class="vx-col w-full">
                            <label for="" class="vs-input--label"
                              >Postcodegegevens</label
                            >
                            <ValidationProvider
                              :name="'Postcode'"
                              :rules="{
                                required: true,
                                regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                              }"
                              v-slot="{ errors }"
                            >
                              <vs-input
                                class="w-full"
                                @change="() => lookupPostcode()"
                                label-placeholder="Postcode"
                                v-model="rehousing.zip_code"
                              />
                              <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="vx-row mb-2">
                          <div class="vx-col w-full">
                            <ValidationProvider
                              :name="'Huisnummer'"
                              rules="required|numeric"
                              v-slot="{ errors }"
                            >
                              <vs-input
                                class="w-full"
                                @change="() => lookupPostcode()"
                                label-placeholder="Huisnummer"
                                v-model="rehousing.house_number"
                              />
                              <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                          </div>
                        </div>
                        <div class="vx-row mb-2">
                          <div class="vx-col w-full">
                            <vs-input
                              class="w-full"
                              label-placeholder="Toevoeging"
                              v-model="house_number_addition"
                              @change="() => lookupPostcode()"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/2 w-full">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <div class="vx-row mb-2">
                          <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Adres</label>
                            <div
                              class="ml-3"
                              v-if="address.street && address.city"
                            >
                              <div>
                                {{ address.street }} {{ address.number }}
                                {{ rehousing.house_number_addition }}
                              </div>
                              <div>
                                {{ address.postcode }} {{ address.city.label }}
                              </div>
                            </div>
                            <div v-else class="ml-3">
                              <i
                                >Vul eerst je postcode en huisnummer in om je
                                volledige adres te zien.</i
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </validation-observer>
            </tab-content>
            <tab-content
              title="Verhuisdatum"
              class="mb-5"
              icon="feather icon-calendar"
              :before-change="validateStep2"
            >
              <validation-observer ref="observerStep2">
                <div class="vx-row">
                  <div class="vx-col mb-4 w-full">
                    <div class="vx-row mb-2">
                      <div class="vx-col w-full lg:w-1/2 ml-auto mr-auto">
                        <label for="" class="vs-input--label"
                          >Verhuisdatum van huidig adres</label
                        >
                        <ValidationProvider
                          :name="'Verhuisdatum van huidig adres'"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <datepicker
                            placeholder="Verhuisdatum van huidig adres"
                            :format="customFormatter"
                            v-model="rehousing.old_rehousing_date"
                            :disabled-dates="disabled_dates"
                            class="mt-4"
                          ></datepicker>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="vx-row mb-2">
                      <div class="vx-col w-full lg:w-1/2 ml-auto mr-auto">
                        <label for="" class="vs-input--label"
                          >Verhuisdatum naar nieuw adres</label
                        >
                        <ValidationProvider
                          :name="'Verhuisdatum naar nieuw adres'"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <datepicker
                            placeholder="Verhuisdatum naar nieuw adres"
                            :format="customFormatter"
                            v-model="rehousing.new_rehousing_date"
                            :disabled-dates="disabled_dates"
                            class="mt-4"
                          ></datepicker>
                          <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </div>
                </div>
              </validation-observer>
            </tab-content>
            <tab-content
              title="Controleren"
              class="mb-5"
              icon="feather icon-check-circle"
            >
              <div class="vx-row">
                <div class="vx-col mb-4 w-full">
                  <div class="vx-row mb-2">
                    <div class="vx-col w-full lg:w-1/2 ml-auto mr-auto">
                      <table>
                        <tr>
                          <th>Verhuisdatum van huidig adres:</th>
                          <td>
                            {{ customFormatter(rehousing.old_rehousing_date) }}
                          </td>
                        </tr>
                        <tr>
                          <th>Verhuisdatum naar nieuw adres:</th>
                          <td>
                            {{ customFormatter(rehousing.new_rehousing_date) }}
                          </td>
                        </tr>
                        <tr>
                          <th>Postcode:</th>
                          <td>
                            {{ rehousing.zip_code }}
                          </td>
                        </tr>
                        <tr>
                          <th>Huisnummer:</th>
                          <td>
                            {{ rehousing.house_number }}
                          </td>
                        </tr>
                        <tr>
                          <th>Toevoeging:</th>
                          <td>
                            {{ rehousing.house_number_addition }}
                          </td>
                        </tr>
                        <tr v-if="address.street && address.city">
                          <th style=" vertical-align: text-top;">
                            Volledig adres:
                          </th>
                          <td>
                            <div>
                              {{ address.street }} {{ address.number }}
                              {{ rehousing.house_number_addition }}
                            </div>
                            <div>
                              {{ address.postcode }} {{ address.city.label }}
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
          <div v-if="finished">
            <vs-alert color="success" title="Verhuizing" active="true">
              We hebben je verhuizing ontvangen. We gaan voor je aan de slag om
              je contract op je nieuwe adres te zetten.
            </vs-alert>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import contractInfo from "@/components/contractInfo.vue";
import { mapState } from "vuex";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import moment from "moment";
moment.locale("nl");
import Datepicker from "vuejs-datepicker";
import axios from "../axios";

import {
  ValidationObserver,
  extend,
  localize,
  ValidationProvider
} from "vee-validate";
import nl from "vee-validate/dist/locale/nl.json";
import { required, numeric, regex } from "vee-validate/dist/rules";
import Logging from "../services/Logging";

extend("numeric", numeric);
extend("required", required);
extend("regex", regex);
localize("nl", nl);

export default {
  data() {
    return {
      house_number_addition: null,
      rehousing: {},
      address: {},
      finished: false,
      disabled_dates: {
        to: moment()
          .add(6, "days")
          .toDate()
      }
    };
  },
  props: ["contractId"],
  computed: {
    ...mapState(["contracts"]),
    contract: function() {
      return this.contracts.find(c => c.id == this.contractId);
    }
  },
  components: {
    contractInfo,
    Datepicker,
    FormWizard,
    TabContent,
    ValidationObserver,
    ValidationProvider
  },
  methods: {
    customFormatter(date) {
      return moment(date).format("dddd DD MMMM YYYY");
    },
    async onComplete() {
      try {
        await axios().post(`/api/contracts/rehouse`, {
          ...this.rehousing,
          contract_id: this.contractId
        });
        this.finished = true;
      } catch (err) {
        Logging.logException(err);
      }
    },
    async validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.observerStep1.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    async validateStep2() {
      return new Promise((resolve, reject) => {
        this.$refs.observerStep2.validate().then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    async lookupPostcode() {
      try {
        var response = await axios().get(
          `/api/Contracts/postcode_lookup?postcode=${this.rehousing.zip_code}&huisnummer=${this.rehousing.house_number}`
        );
        this.address = response.data;
      } catch {
        this.address = {};
      }

      this.rehousing.house_number_addition = this.house_number_addition;
    }
  }
};
</script>

<style></style>
